import { HttpClient } from '../HttpClient';
/**
 * * Get Project Statuses
 */

export const GetProjectStatuses = async () => {
  try {
    const { data } = await HttpClient.get(`api/lookups/ProjectStatuses`);
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
